import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { LinearProgress } from '@material-ui/core';

import { AnalyticsTracker, useAnalytics } from '@backstage/core-plugin-api';

import { useAuth } from '@spotify/confidence-core-react';
import { useAccounts } from '@spotify/plugin-confidence-app-react';

import { urlFromResource } from './utils';

const notificationClicked = (
  params: URLSearchParams,
  analytics: AnalyticsTracker,
) => {
  const activityId = params.get('activity');
  if (activityId) {
    analytics.captureEvent('notification-clicked', 'redirect', {
      attributes: {
        activityId: activityId,
      },
    });
  }
};

const RedirectHandler = () => {
  const location = useLocation();
  const { selectedAccountId, isLoading, isSwitching, switchAccount } =
    useAccounts();

  const {
    isAuthenticated,
    isLoading: authIsLoading,
    loginWithRedirect,
  } = useAuth();
  const analytics = useAnalytics();

  useEffect(() => {
    const handleAccount = async () => {
      const params = new URLSearchParams(location.search);
      const account = params.get('account');
      const resource = params.get('resource');

      if (resource) {
        const newUrl = urlFromResource(resource);
        notificationClicked(params, analytics);

        if (!authIsLoading && !isAuthenticated) {
          loginWithRedirect({
            appState: {
              returnTo: newUrl,
            },
          });
        } else if (account === null || account === selectedAccountId) {
          window.location.href = newUrl;
          return;
        } else if (
          account &&
          account !== selectedAccountId &&
          !isLoading &&
          !isSwitching
        ) {
          await switchAccount(account, newUrl);
        }
      }
    };

    handleAccount();
  }, [
    selectedAccountId,
    isLoading,
    isSwitching,
    switchAccount,
    isAuthenticated,
    authIsLoading,
  ]);

  return <LinearProgress />;
};

export default RedirectHandler;
